import React from "react";
import { faArrowLeft, faLessThan, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useState } from "react";
import Modal from "react-modal";
import { Button } from "reactstrap";
import AlertComponent from "../alert/AlertComponent";
import "./ModalComponent.scss";
import { StyledTooltip } from "../../views/project/label/annotation/EditorView/EditorTopNavigationBar/EditorTopNavigationBar";
Modal.setAppElement("body");
export const alertContext = React.createContext();

export default function ModalComponent2({
  modalIsOpen,
  setModalIsOpen,
  modalClass,
  component,
}) {
  const closeModal = () => {
    setModalIsOpen();
  };
  const [alert, setAlert] = useState();

  return (
    <div>
      <AlertComponent alert={alert} />
      {modalIsOpen?.length > 0 &&    <div className={modalClass === "evaluate" ? "modelcard3" : "modelcard2"}>
        <div className="m-4 ms-4 mb-2 cursor-pointer">
          <FontAwesomeIcon className="button-icon" icon={faArrowLeft} onClick={closeModal}/>
        </div>
        <alertContext.Provider value={setAlert}>
          {component}
        </alertContext.Provider>
        </div>}
    </div>
  );
}
